import { render, staticRenderFns } from "./TestimonialTable.vue?vue&type=template&id=287a870c"
import script from "./TestimonialTable.vue?vue&type=script&lang=js"
export * from "./TestimonialTable.vue?vue&type=script&lang=js"
import style0 from "./TestimonialTable.vue?vue&type=style&index=0&id=287a870c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports